import { createNewsLetterApi } from '../../core/js/newsletter-api/index.js';

export const newsletterApApi = createNewsLetterApi(
  'https://newsletter.aftenposten.no',
  'AP',
);

export const newsletterByfunnApi = createNewsLetterApi(
  'https://newsletter.aftenposten.no',
  'VINK',
);
